module.exports = __webpack_public_path__ + "static/media/WkFooter.ee1e6131.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/WkFooter.PNG
// module id = 1653
// module chunks = 1